import React from 'react';
import { STATUS_COLORS, STATUS_LABELS } from '../../../lib/acceleratorApi';

export default function StatusBadge({ status }) {
  return (
    <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${STATUS_COLORS[status] || 'bg-white/10 text-white/70'}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function StatCard({ label, value, icon: Icon }) {
  return (
    <div className="bg-white/[0.03] border border-white/10 rounded-xl p-5">
      <div className="flex items-center justify-between mb-2">
        <span className="text-white/50 text-sm">{label}</span>
        {Icon && <Icon className="w-4 h-4 text-[#d42b92]" />}
      </div>
      <div className="text-2xl font-semibold text-white">{value}</div>
    </div>
  );
}

export function EmptyState({ message }) {
  return <div className="py-12 text-center text-white/40 text-sm">{message}</div>;
}

export function Modal({ open, onClose, title, children, wide }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose}>
      <div
        className={`bg-[#12121a] border border-white/10 rounded-2xl p-6 w-full ${wide ? 'max-w-2xl' : 'max-w-lg'} max-h-[90vh] overflow-y-auto`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          <button onClick={onClose} className="text-white/40 hover:text-white text-xl leading-none">&times;</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Btn({ children, variant = 'primary', className = '', ...props }) {
  const variants = {
    primary: 'bg-[#d42b92] hover:bg-[#ff8ec5] text-white',
    secondary: 'bg-white/5 hover:bg-white/10 text-white/80 border border-white/10',
    danger: 'bg-red-500/20 hover:bg-red-500/30 text-red-300 border border-red-500/30',
    success: 'bg-green-500/20 hover:bg-green-500/30 text-green-300 border border-green-500/30'
  };
  return (
    <button
      className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors disabled:opacity-50 ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function Input({ label, ...props }) {
  return (
    <div>
      {label && <label className="block text-sm text-white/60 mb-1">{label}</label>}
      <input
        className="w-full bg-black/40 border border-white/10 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-[#d42b92]"
        {...props}
      />
    </div>
  );
}

export function Select({ label, options, ...props }) {
  return (
    <div>
      {label && <label className="block text-sm text-white/60 mb-1">{label}</label>}
      <select
        className="w-full bg-black/40 border border-white/10 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-[#d42b92]"
        {...props}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
}

export function Textarea({ label, ...props }) {
  return (
    <div>
      {label && <label className="block text-sm text-white/60 mb-1">{label}</label>}
      <textarea
        className="w-full bg-black/40 border border-white/10 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-[#d42b92] min-h-[80px]"
        {...props}
      />
    </div>
  );
}
